import { render } from "./IconPhone.vue?vue&type=template&id=0c65830e&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconPhone.vue?vue&type=script&lang=js"
export * from "./IconPhone.vue?vue&type=script&lang=js"
script.render = render

export default script